import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'
import querystring from 'querystring'

require('./../../security/interceptors')

const balances = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/dashboard/balances?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o saldo.')
        })
}

const balanceSend = () => {
    return api.get('/dashboard/balanceSend')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o valor enviado')
        })
}

const balanceReceived = () => {
    return api.get('/dashboard/balanceReceived')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o valor recebido')
        })
}

export default {
    balances,
    balanceSend,
    balanceReceived
}
